var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { CreditCardIcon, MenuItem, translate } from '@lucidlink/uicore';
export const BillingMenuItem = ({ hidden, workspaceId, }) => {
    return (_jsx(MenuItem, { "data-testid": "billing", hidden: hidden, LeadingIcon: CreditCardIcon, text: translate('Billing and invoices'), to: `/workspaces/${workspaceId}/settings/billing` }));
};
_react_refresh_temp_1 = BillingMenuItem;
$RefreshReg$(_react_refresh_temp_1, "BillingMenuItem");
